import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import ProductCard from "@/components/Cards/ProductCard";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ListProductNew: React.FC = () => {
    const [treeData, setTreeData] = useState<any | null>(null);
    const { id } = useParams<{ id: string }>();


    const {
        data: allDatas,
        isLoading,
        error,
    } = useFetchApi({
        url: "/v1/gp/67850933e23ada9e6aa61f3c/tr/find?list_related=false&list_referenced=false&limit=0&skip=0&search=parentId:$eq:" + id,
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        },
    });




    return (
        <>
            <BreadCrumb title="Gazlar" parent="Ürünler" child="Gazlar" />

            <section className="ls section_padding_top_135 section_padding_bottom_90 columns_padding_25">
                <div className="container">
                    <div className="row columns_margin_bottom_40 services-row">
                        {isLoading && <Loader />}

                        {!isLoading && (
                            <>
                                {allDatas?.results?.map((node: any, index: number) => {
                                    return (
                                        <ProductCard
                                            data={{
                                                title: node.title,
                                                content: node.content,
                                                Ozellikleri: node.ozellikleri,
                                                Urun_Gami: node.Urun_Gami,
                                                Kullanim_Alani: node.Kullanim_Alani,
                                                Depolama: node.Depolama,
                                                Tehlike_Aciklamasi: node.Tehlike_Aciklamasi,
                                                Acil_Durum: node.Acil_Durum,
                                                icon: node.icon,
                                                image: node.image,
                                                fix_name: node.fix_name,
                                                node: true,
                                                _id: node._id,
                                                url: '/product-detail/' + node._id
                                            }}
                                            isLoading={false}
                                            key={node._id}
                                        />
                                    )
                                })}
                            </>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ListProductNew;